module.exports = __webpack_public_path__ + "img/role.292745df.svg";